// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Message_wrapper_3XO64"};